import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useNullableDealerAccountInfo } from "../../../../../stores/hooks/useNullableDealerAccountInfo";
import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { useRunFlat } from "./useRunFlat";
import { useRunFlatOptions } from "./useRunFlatOptions";

const id = "dealer-tire-run-flat-panel";

export const TireRunFlatFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const options = useRunFlatOptions();
  const [, { toggle }] = useRunFlat();
  const dealer = useNullableDealerAccountInfo();
  if (!dealer?.dealerProductFilters.runFlatTireFilter) {
    return null;
  }
  return (
    <Collapsible
      className="space-y-2"
      id={id}
      label={t("searchResults.runFlat")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, label, value }) => (
        <label className="flex gap-x-4" key={value}>
          <Checkbox
            onChange={(): void => {
              toggle([value]);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            name="brand"
          />
          <span className="flex-1">{label}</span>
        </label>
      ))}
    </Collapsible>
  );
};
